import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách địa chỉ
 */
export const fetchListAddress = createAsyncThunk(
  'get/users/v3/users/customer/address/list',
  async (_, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/users/customer/address/list',
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data || [],
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy chi tiết địa chỉ theo ID
 * @param {string} addressId ID của địa chỉ
 */
export const getDetailAddress = createAsyncThunk(
  'get/users/v3/users/customer/address/id',
  async (addressId, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/users/customer/address/' + addressId,
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API xóa địa chỉ theo ID
 * @param {string} addressId ID của địa chỉ
 */
export const deleteAddress = createAsyncThunk(
  'delete/users/v3/users/customer/address/delete',
  async (addressId, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/users/customer/address/delete/' + addressId,
        method: 'delete',
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API tạo địa chỉ mới
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.name Họ và tên
 * @param {string} values.phone Số điện thoại
 */
export const createAddress = createAsyncThunk(
  'post/users/v3/users/customer/address',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/users/customer/address',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API cập nhật địa chỉ
 * @param {Object} values Dữ liệu gửi lên API
 */
export const updateAddress = createAsyncThunk(
  'put/users/v3/users/customer/address/update/id',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/users/customer/address/update/' + values.id,
        method: 'put',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy danh sách tỉnh thành
 */
export const fetchProvinces = createAsyncThunk(
  'get/https://partnerdev.viettelpost.vn/v3/categories/listProvinceNew',
  async (_, { dispatch }) => {
    try {
      const res = await callApi({
        baseURL: 'https://partnerdev.viettelpost.vn',
        endpoint: '/v3/categories/listProvinceNew',
        method: 'get',
      });

      const response = res.data;
      if (response.status === 200) {
        return {
          data: (response?.data || []).map(item => ({
            province_id: item.PROVINCE_ID,
            code: item.PROVINCE_CODE,
            name: item.PROVINCE_NAME,
          })),
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy danh sách phường xã
 * @param {string} provinceId Mã tỉnh thành
 */
export const fetchWards = createAsyncThunk(
  'get/https://partnerdev.viettelpost.vn/v3/categories/listWardsNew?provinceId={id}',
  async ({ provinceId }, { dispatch }) => {
    try {
      const res = await callApi({
        baseURL: 'https://partnerdev.viettelpost.vn',
        endpoint: '/v3/categories/listWardsNew',
        method: 'get',
        params: { provinceId },
      });

      const response = res.data;
      if (response.status === 200) {
        return {
          data: (response?.data || []).map(item => ({
            wards_id: item.WARDS_ID,
            code: item.WARDS_CODE,
            name: item.WARDS_NAME,
            province_id: item.PROVINCE_ID,
          })),
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

/**
 * Gọi API lấy danh sách phường xã
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} provinceCode Mã tỉnh thành
 * @param {string} wardCode Mã phường xã
 */
export const fetchFullAddress = createAsyncThunk(
  'get/https://tinhthanhpho.com/api/v1/new-full-address',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        baseURL: 'https://tinhthanhpho.com/api/v1',
        endpoint: `/new-full-address`,
        method: 'get',
        params: values,
        headers: {
          Authorization: 'Bearer hvn_t491txYz9fK3VYTRHRugeso1xuYR6gmd',
        },
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response?.data || [],
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
